import PageTitle from "@component/PageTitle";
import useIntRouteParam from "@hooks/useIntRouteParam";
import { RootState } from "@redux/rootReducer";
import { fetchVendorDetail, updateVendor } from "@redux/vendorSlice";
import { message, Tabs, Tag } from "antd";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/store";
import { TabWithButtonWrapper, TabWrapper } from "src/styles/common";
import MarginManagement from "./MarginManagement";
import SalesRecord from "./SalesRecord";
import VendorContacts from "./VendorContacts";
import VendorSource from "./VendorSource";
import { EditStatus, tagMap } from "./constant";
import useVendorBasicEditPermission from "./hooks/useVendorBasicEditability";
import VendorDetails from "./VendorDetails";
import { UpdateVendorPayload } from "./interface";

const { TabPane } = Tabs;

export default function VendorInfoPage() {
  const vendorId = useIntRouteParam("vendorId", true);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") || EditStatus.VIEW; // 'view' | 'basic' | 'others'
  const { vendorDetail } = useSelector((state: RootState) => state.vendorSlice);

  const { applicationStatus, sourceId } = vendorDetail || {};
  const { canEditBasicStatus } = useVendorBasicEditPermission();

  const tagInfo = applicationStatus ? tagMap[applicationStatus] : null;
  const TagIcon = tagInfo?.icon;

  const isViewMode = mode === EditStatus.VIEW;
  // 只有在特定狀態下且 mode 為 BASIC 時才允許編輯基本資訊
  const canEditBasic = mode === EditStatus.BASIC && canEditBasicStatus(applicationStatus || 0);

  const handleFinish = async (values: UpdateVendorPayload) => {
    if (!vendorId || !canEditBasic) return;
    try {
      await dispatch(updateVendor({ id: vendorId, payload: values })).unwrap();
      message.success("更新成功");
      dispatch(fetchVendorDetail(vendorId));
    } catch {
      // 錯誤由 CoreAPI interceptor 統一處理
    }
  };
  useEffect(() => {
    if (vendorId) dispatch(fetchVendorDetail(vendorId));
  }, [dispatch, vendorId]);

  if (!vendorDetail) return null;
  return (
    <TabWrapper>
      <PageTitle title={`廠商資訊 - ${vendorDetail.name}`} />
      {tagInfo && (
        <TabWithButtonWrapper>
          <Tag icon={TagIcon && <TagIcon />} color={tagInfo.color}>
            {`${tagInfo.text} ${vendorDetail?.rejectReason ? ` : ${vendorDetail?.rejectReason}` : ""}`}
          </Tag>
        </TabWithButtonWrapper>
      )}
      <Tabs defaultActiveKey="1" type="card" size="small">
        <TabPane tab="廠商基本資料" key="1">
          <VendorDetails readOnly={isViewMode || !canEditBasic} onFinish={handleFinish} showSubmit={canEditBasic} />
        </TabPane>
        {/* sourceId表示有曾經完成過審核並同步到ERP */}
        {sourceId && (
          <>
            <TabPane tab="聯絡資訊" key="2">
              <VendorContacts />
            </TabPane>

            <TabPane tab="廠商貨源" key="3">
              <VendorSource source={[]} />
            </TabPane>

            <TabPane tab="保證金管理" key="4">
              <MarginManagement />
            </TabPane>

            <TabPane tab="銷售紀錄" key="5">
              <SalesRecord />
            </TabPane>
          </>
        )}
      </Tabs>
    </TabWrapper>
  );
}
